import { useCalendarData } from '@calendly/ui/hooks/use-calendar-data';
import classNames from 'classnames';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Controls } from './controls';
import { DayLoader } from './day_loader';
import { NoDatesAvailable } from './no_dates_available';
import { Title } from './title';
import { Week } from './week';
import { WeekContainer } from './week_container';
import { WeekDays } from './week_days';
const containerCss = "c18xfx8w";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const headerContainerCss = "h1yw04rr";
const HeaderContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerContainerCss, props.className)} />;
});
const weekDaysHeaderCss = "wew96w3";
const WeekDaysHeader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'thead';
  return <Component ref={ref} {...restProps} className={classNames(weekDaysHeaderCss, props.className)} />;
});
const calendarTableIsTabletUpCss = "c1e97vgk";
const calendarTableCss = "c1exfzul";
const CalendarTable = forwardRef((props, ref) => {
  const {
    isTabletUp,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'table';
  return <Component ref={ref} {...restProps} className={classNames(calendarTableCss, {
    [calendarTableIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
export const Calendar = ({
  selectedDay,
  selectedSpots,
  availableDays,
  showSubscript,
  onDayClick,
  isDaysLoading,
  timezone,
  currentMonthId,
  setCurrentMonthId,
  stylePrimary,
  pastDisabled = false,
  showSurroundingMonths = false,
  ...props
}) => {
  const {
    title,
    weekdays,
    weeks,
    nextMonthId,
    prevMonthId
  } = useCalendarData(currentMonthId, timezone);
  const month = moment(currentMonthId, 'YYYY-MM');
  const monthId = parseInt(month.format('YYYYMM'), 10);
  const prevMonth = () => setCurrentMonthId(prevMonthId);
  const nextMonth = () => setCurrentMonthId(nextMonthId);
  const prevMonthDisabled = pastDisabled && prevMonthId < moment.tz(timezone).startOf('month').format('YYYY-MM');
  const allDays = weeks.flat().filter(({
    isInCurrentMonth
  }) => isInCurrentMonth).map(({
    id
  }) => id);
  const isMonthAvailable = Object.keys(availableDays).some(day => allDays.includes(day));
  return <Container {...props}>
      <HeaderContainer>
        <Title id={monthId}>{title}</Title>
        <Controls prevMonth={prevMonth} nextMonth={nextMonth} prevMonthDisabled={prevMonthDisabled} />
      </HeaderContainer>
      <CalendarTable>
        <WeekDaysHeader>
          <WeekDays weekdays={weekdays} />
        </WeekDaysHeader>
        <WeekContainer id={monthId}>
          {weeks.map(week => <Week week={week} key={week[0].id} selectedDay={selectedDay} selectedSpots={selectedSpots} showSubscript={showSubscript} availableDays={availableDays} onDayClick={onDayClick} stylePrimary={stylePrimary} timezone={timezone} showSurroundingMonths={showSurroundingMonths} />)}
        </WeekContainer>
      </CalendarTable>
      {isDaysLoading && <DayLoader />}
      {!isDaysLoading && !isMonthAvailable && <NoDatesAvailable onClick={nextMonth} month={moment(month).locale('en').format('MMMM')} />}
    </Container>;
};
Calendar.propTypes = {
  selectedDay: PropTypes.string.isRequired,
  availableDays: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool]))).isRequired,
  selectedSpots: PropTypes.arrayOf(PropTypes.string).isRequired,
  showSubscript: PropTypes.bool.isRequired,
  onDayClick: PropTypes.func.isRequired,
  isDaysLoading: PropTypes.bool.isRequired,
  timezone: PropTypes.string.isRequired,
  currentMonthId: PropTypes.string.isRequired,
  setCurrentMonthId: PropTypes.func.isRequired,
  stylePrimary: PropTypes.bool.isRequired,
  pastDisabled: PropTypes.bool,
  showSurroundingMonths: PropTypes.bool
};

require("./calendar.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./calendar.js");